import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { resumeData } from "./data/mock";

// Components
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Experience from "./components/Experience";
import Education from "./components/Education";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import { Contact, Footer } from "./components/Contact";

const ResumePage = () => {
  return (
    <div className="bg-[#0a1628] min-h-screen">
      <Header data={resumeData.personal} />
      <Hero data={resumeData.personal} stats={resumeData.stats} />
      <About data={resumeData.personal} />
      <Projects data={resumeData.projects} />
      <Experience data={resumeData.experience} />
      <Skills data={resumeData.skills} />
      <Education data={resumeData.education} />
      <Contact data={resumeData.personal} />
      <Footer data={resumeData.personal} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ResumePage />} />
          <Route path="*" element={<ResumePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
